import { USER_AUTH_TYPE } from "../enums/user-auth-type.enum"

export const getAuthTypeLabel = (userAuthType: USER_AUTH_TYPE) => {
  return userAuthType === USER_AUTH_TYPE.COMARCH_EMPLOYEE ? 'Invitation' : 'Registration'
}